import React, { PureComponent } from 'react';
import { ContentFocusedLACard } from 'appSrc/components/List-Article';
import PropTypes from 'prop-types';
import { VariableLink } from 'appSrc/components/UI';
import style from './styles/style.module.css';


class ContentFocusedCardSet extends PureComponent {
    render() {
        const { carousel } = this.props;
        const content = carousel.content || [];

        return (
            <div className={ `${ style.productFocusedCardSet } ${ this.props.className }`.trim() }>
                { content.length > 0 &&
                    <div className={ style.carouselWrapper }>
                        <div className={ 'carousel-title-bar ' + style.carouselTitleBar }>
                            <h2>{ carousel.title }</h2>
                            { carousel.link_url &&
                                <VariableLink to={ carousel.link_url }>{ carousel.link_text || 'See All' }</VariableLink>
                            }
                        </div>
                        <div className={ style.set }>
                            { content[ 0 ] &&
                                <div className={ style.cardWrapper }>
                                    <ContentFocusedLACard item={ content[ 0 ] } />
                                </div>
                            }
                            { content[ 1 ] &&
                                <div className={ style.spacer } />
                            }
                            { content[ 1 ] &&
                                <div className={ style.cardWrapper }>
                                    <ContentFocusedLACard item={ content[ 1 ] } />
                                </div>
                            }
                        </div>
                    </div>
                }
            </div>
        );
    }
}
ContentFocusedCardSet.propTypes = {
    className: PropTypes.string,
    carousel: PropTypes.object,
};
ContentFocusedCardSet.defaultProps = {
    className: '',
    carousel: {},
};

export default ContentFocusedCardSet;
